import { Layers, Package, Tag } from 'lucide-react';
import { useState } from 'react';
import { CategoriasTab } from './components/CategoriasTab';
import { GruposTab } from './components/GruposTab';
import { ProdutosTab } from './components/ProdutosTab';

type Tab = 'produtos' | 'categorias' | 'grupos';

const TABS: Array<{ id: Tab; label: string; icon: typeof Package }> = [
  { id: 'produtos', label: 'Produtos', icon: Package },
  { id: 'categorias', label: 'Categorias', icon: Tag },
  { id: 'grupos', label: 'Complementos', icon: Layers },
];

export function ProdutosPage() {
  const [tab, setTab] = useState<Tab>('produtos');

  return (
    <div className="flex flex-col gap-5">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900">Catalogo</h1>
        <p className="mt-1 text-sm text-slate-500">
          Gerencie produtos, categorias e grupos de complementos do seu PDV.
        </p>
      </header>

      <div className="flex gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              className={`inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 text-sm font-medium transition ${
                active
                  ? 'bg-brand-600 text-white'
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              }`}
            >
              <Icon className="h-4 w-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      <div>
        {tab === 'produtos' && <ProdutosTab />}
        {tab === 'categorias' && <CategoriasTab />}
        {tab === 'grupos' && <GruposTab />}
      </div>
    </div>
  );
}
